import { render, staticRenderFns } from "./paperView.vue?vue&type=template&id=f52ba446&scoped=true"
import script from "./paperView.vue?vue&type=script&lang=js"
export * from "./paperView.vue?vue&type=script&lang=js"
import style0 from "./paperView.vue?vue&type=style&index=0&id=f52ba446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52ba446",
  null
  
)

export default component.exports